import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './bai-viet.reducer';

export const BaiVietDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const baiVietEntity = useAppSelector(state => state.baiViet.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="baiVietDetailsHeading">
          <Translate contentKey="xtdtApp.baiViet.detail.title">BaiViet</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{baiVietEntity.id}</dd>
          <dt>
            <span id="tieuDe">
              <Translate contentKey="xtdtApp.baiViet.tieuDe">Tieu De</Translate>
            </span>
          </dt>
          <dd>{baiVietEntity.tieuDe}</dd>
          <dt>
            <span id="moTa">
              <Translate contentKey="xtdtApp.baiViet.moTa">Mo Ta</Translate>
            </span>
          </dt>
          <dd>{baiVietEntity.moTa}</dd>
          <dt>
            <span id="anhDaiDien">
              <Translate contentKey="xtdtApp.baiViet.anhDaiDien">Anh Dai Dien</Translate>
            </span>
          </dt>
          <dd>{baiVietEntity.anhDaiDien}</dd>
          <dt>
            <span id="noiDung">
              <Translate contentKey="xtdtApp.baiViet.noiDung">Noi Dung</Translate>
            </span>
          </dt>
          <dd>{baiVietEntity.noiDung}</dd>
          <dt>
            <Translate contentKey="xtdtApp.baiViet.diaPhuong">Dia Phuong</Translate>
          </dt>
          <dd>{baiVietEntity.diaPhuong ? baiVietEntity.diaPhuong.id : ''}</dd>
          <dt>
            <Translate contentKey="xtdtApp.baiViet.loaiQuyHoach">Loai Quy Hoach</Translate>
          </dt>
          <dd>{baiVietEntity.loaiQuyHoach ? baiVietEntity.loaiQuyHoach.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/bai-viet" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/bai-viet/${baiVietEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BaiVietDetail;
